import { compose } from 'redux';
import { connect } from 'react-redux';
import withStyles from '@material-ui/styles/withStyles';
import { Grid, Dialog, DialogContent } from '@material-ui/core';

import { LoadingOverlay } from 'altus-ui-components';
import { getSummarizedDataStateFromState } from 'app/app.selectors';

import { EQUIPMENT_ACTIONS } from 'features/equipment/equipment.constants';
import AddSurfaceEquipmentForm from 'features/equipment/surfaceEquipment/surfaceEquipmentModalForm/AddSurfaceEquipmentForm';
import AddSurfaceEquipmentModalHeader from 'features/equipment/surfaceEquipment/surfaceEquipmentModalForm/AddSurfaceEquipmentModalHeader';

const AddSurfaceEquipmentModal = ({
  open,
  tool,
  edit,
  title,
  classes,
  saveTool,
  onSubmit,
  validForm,
  dataState,
  suppliers,
  toolGroups,
  toggleModal,
  toolConnectors,
  requiredFields,
  initialFormValues,
  unitsOfMeasurePreference,
}) => {
  return (
    <>
      <Dialog
        fullWidth
        open={open}
        onClose={toggleModal}
        classes={{ paperScrollPaper: classes.root }}
      >
        <Grid className={classes.header}>
          <AddSurfaceEquipmentModalHeader
            closeModal={toggleModal}            
            title={title ? title : 'Surface equipment'}
          />
        </Grid>
        <DialogContent className={classes.content}>
          <AddSurfaceEquipmentForm
            edit={edit}
            tool={tool}
            saveTool={saveTool}
            onSubmit={onSubmit}
            validForm={validForm}
            toolGroups={toolGroups}
            toolSuppliers={suppliers}
            toolConnectors={toolConnectors}
            requiredFields={requiredFields}
            initialFormValues={initialFormValues}
            unitsOfMeasurePreference={unitsOfMeasurePreference}
          />
        </DialogContent>
        <LoadingOverlay dataState={dataState} text={'Saving tool...'} />
      </Dialog>
    </>
  );
};

const styles = (theme) => ({
  root: {
    height: 'fit-content',
  },
  content: {
    overflow: 'scroll-y',
  },
  header: {
    padding: theme.spacing(3),
  },
  footer: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  filters: {
    paddingBottom: theme.spacing(2),
  },
  table: {
    paddingBottom: theme.spacing(2),
  },
});

export default compose(
  connect((state) => ({
    dataState: getSummarizedDataStateFromState(
      state,
      EQUIPMENT_ACTIONS.CREATE_SURFACE_EQUIPMENT,
    ),
  })),
  withStyles(styles),
)(AddSurfaceEquipmentModal);
